<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">{{ $t("stakeholders") }}</div>
		<div class="bt1 bc7 p4" slot="body">
			<core-stakeholders-card
				:caseId="$store.state.caseManagement.caseId"
				:proposalId="$store.state.caseManagement.proposalId"
				:offerId="$store.state.caseManagement.offerId"
				:stakeholders="stakeholders"
				stakeholdersOf="offer"
				@stakeholder:added="addStakeholder($event)"
				@stakeholder:removed="removeStakeholder($event)"
				variant="no-headline"
			/>
		</div>
	</j-expendable-box>
</template>

<script>
import JExpendableBox from "@/components/JExpendableBox"

import CoreStakeholdersCard from "@/modules/core/components/CoreStakeholdersCard/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JExpendableBox, CoreStakeholdersCard },

	data() {
		return {
			stakeholders: []
		}
	},

	methods: {
		async fetchStakeholders() {
			this.stakeholders = this.$store.getters[
				"caseManagement/offer"
			]?.stakeholders
		},

		async addStakeholder(value) {
			const stateFilter = function(state) {
				return state.proposals
					?.find(item => item.id === state?.proposalId)
					?.basket?.find(item => item.id === state?.offerId)
			}
			// Update type
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "push",
				fieldName: "stakeholders",
				value: value,
				stateFilter
			})

			this.fetchStakeholders()
		},

		async removeStakeholder(id) {
			const stateFilter = function(state) {
				return state.proposals
					?.find(item => item.id === state?.proposalId)
					?.basket?.find(item => item.id === state?.offerId)?.stakeholders
			}
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "remove",
				fieldName: "id",
				value: id,
				stateFilter
			})

			this.fetchStakeholders()
		}
	},

	created() {
		this.fetchStakeholders()
	}
}
</script>
